export default __webpack_public_path__ + "static/media/Cloudxier-BENEDICTUS BILLY-Profile-Content.abc70f11.png";